export default __webpack_public_path__ + "static/media/imageCover.fd2a1bcb.svg";